// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
    position: fixed;
    z-index: 1;
    -webkit-tap-highlight-color: transparent;
    left: 0;
    bottom: 0;
    width: 100%;
    background: var(--mdh-background-color-1);
    white-space: nowrap;
    text-align: center;
    z-index: 2;
    border-top: solid 1px var(--mdh-border-color-2);
    overflow-x: auto;
}

.tabs .tab {
    color: var(--mdh-text-color-2);
    cursor: pointer;
    text-decoration: none;
    position: relative;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 55px;
    box-sizing: border-box;
}

.tabs .tab.selected {
    color: var(--default-highlight-color);
}

.tabs .tab img {
    filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(83%) contrast(76%);
    -webkit-filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(83%) contrast(76%);
}

.tabs .tab.selected img {
    filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(90%) contrast(110%);
    -webkit-filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(90%) contrast(110%);
}



.tabs .tab .badge {
    position: absolute;
    background: #ea4e3d;
    color: #FFF;
    text-align: center;
    font-size: 13px;
}

.tabs .tab .tab-icon {
    height: 20px;
    text-align: center;
}

.tabs .tab .tab-icon .fa {
    font-size: 20px;
}

.tabs .tab .tab-title {
    display: inline-block;
    width: calc(100% - 8px);
    overflow: hidden;
    text-overflow: ellipsis;
}

.tabs .tab .tab-icon img {
    height: 19px;
}

.tabs .tab .badge {
    right: calc(50% - 20px);
    top: 5px;
    height: 18px;
    border-radius: 9px;
    min-width: 9px;
    padding-left: 4.5px;
    padding-right: 4.5px;
    line-height: 18px;
}

.color-scheme-dark .tabs .tab img {
    filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(133%) contrast(76%);
    -webkit-filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(133%) contrast(76%);
}

.color-scheme-dark .tabs .tab.selected img {
    filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(120%) contrast(110%);
    -webkit-filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(120%) contrast(110%);
}

@media (min-width: 680px) {
    .tabs.tabs-responsive {
        position:absolute;
        left: 16px;
        top: 16px;
        width: 188px;
        z-index: 2;
        border: none;
        white-space: normal;
        background: none;
    }

    .tabs.tabs-responsive .tab {
        display: grid;
        grid-template-columns: 25px auto max-content;
        grid-column-gap: 4px;
        font-size: 18px;
        padding: 8px;
        position: relative;
        text-align: left;
        width: auto !important;
        height: auto;
    }

    .tabs.tabs-responsive .tab .tab-title {
        display: block;
        width: auto;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .tabs.tabs-responsive .tab .tab-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto
    }

    .tabs.tabs-responsive .tab .tab-icon .fa {
        font-size: 16px;
    }

    .tabs.tabs-responsive .tab .tab-icon img {
        width: 18px;
    }

    .tabs.tabs-responsive .tab.selected {
        background: var(--mdh-background-color-2);
        border-radius: 5px;
    }

    .tabs.tabs-responsive .tab .badge {
        right: 0;
        top: 0;
        bottom: 0;
        position: relative;
        height: 20px;
        border-radius: 10px;
        min-width: 10px;
        padding-left: 5px;
        padding-right: 5px;
        line-height: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/Tabs/Tabs.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,UAAU;IACV,wCAAwC;IACxC,OAAO;IACP,SAAS;IACT,WAAW;IACX,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wHAAwH;IACxH,gIAAgI;AACpI;;AAEA;IACI,6HAA6H;IAC7H,qIAAqI;AACzI;;;;AAIA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,yHAAyH;IACzH,iIAAiI;AACrI;;AAEA;IACI,8HAA8H;IAC9H,sIAAsI;AAC1I;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,SAAS;QACT,YAAY;QACZ,UAAU;QACV,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,4CAA4C;QAC5C,oBAAoB;QACpB,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yCAAyC;QACzC,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,MAAM;QACN,SAAS;QACT,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;IACrB;AACJ","sourcesContent":[".tabs {\n    position: fixed;\n    z-index: 1;\n    -webkit-tap-highlight-color: transparent;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background: var(--mdh-background-color-1);\n    white-space: nowrap;\n    text-align: center;\n    z-index: 2;\n    border-top: solid 1px var(--mdh-border-color-2);\n    overflow-x: auto;\n}\n\n.tabs .tab {\n    color: var(--mdh-text-color-2);\n    cursor: pointer;\n    text-decoration: none;\n    position: relative;\n    display: inline-block;\n    text-align: center;\n    font-size: 14px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    height: 55px;\n    box-sizing: border-box;\n}\n\n.tabs .tab.selected {\n    color: var(--default-highlight-color);\n}\n\n.tabs .tab img {\n    filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(83%) contrast(76%);\n    -webkit-filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(83%) contrast(76%);\n}\n\n.tabs .tab.selected img {\n    filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(90%) contrast(110%);\n    -webkit-filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(90%) contrast(110%);\n}\n\n\n\n.tabs .tab .badge {\n    position: absolute;\n    background: #ea4e3d;\n    color: #FFF;\n    text-align: center;\n    font-size: 13px;\n}\n\n.tabs .tab .tab-icon {\n    height: 20px;\n    text-align: center;\n}\n\n.tabs .tab .tab-icon .fa {\n    font-size: 20px;\n}\n\n.tabs .tab .tab-title {\n    display: inline-block;\n    width: calc(100% - 8px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tabs .tab .tab-icon img {\n    height: 19px;\n}\n\n.tabs .tab .badge {\n    right: calc(50% - 20px);\n    top: 5px;\n    height: 18px;\n    border-radius: 9px;\n    min-width: 9px;\n    padding-left: 4.5px;\n    padding-right: 4.5px;\n    line-height: 18px;\n}\n\n.color-scheme-dark .tabs .tab img {\n    filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(133%) contrast(76%);\n    -webkit-filter: brightness(0) saturate(100%) invert(33%) sepia(6%) saturate(0%) hue-rotate(150deg) brightness(133%) contrast(76%);\n}\n\n.color-scheme-dark .tabs .tab.selected img {\n    filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(120%) contrast(110%);\n    -webkit-filter: brightness(0) saturate(100%) invert(30%) sepia(21%) saturate(2959%) hue-rotate(181deg) brightness(120%) contrast(110%);\n}\n\n@media (min-width: 680px) {\n    .tabs.tabs-responsive {\n        position:absolute;\n        left: 16px;\n        top: 16px;\n        width: 188px;\n        z-index: 2;\n        border: none;\n        white-space: normal;\n        background: none;\n    }\n\n    .tabs.tabs-responsive .tab {\n        display: grid;\n        grid-template-columns: 25px auto max-content;\n        grid-column-gap: 4px;\n        font-size: 18px;\n        padding: 8px;\n        position: relative;\n        text-align: left;\n        width: auto !important;\n        height: auto;\n    }\n\n    .tabs.tabs-responsive .tab .tab-title {\n        display: block;\n        width: auto;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .tabs.tabs-responsive .tab .tab-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: auto\n    }\n\n    .tabs.tabs-responsive .tab .tab-icon .fa {\n        font-size: 16px;\n    }\n\n    .tabs.tabs-responsive .tab .tab-icon img {\n        width: 18px;\n    }\n\n    .tabs.tabs-responsive .tab.selected {\n        background: var(--mdh-background-color-2);\n        border-radius: 5px;\n    }\n\n    .tabs.tabs-responsive .tab .badge {\n        right: 0;\n        top: 0;\n        bottom: 0;\n        position: relative;\n        height: 20px;\n        border-radius: 10px;\n        min-width: 10px;\n        padding-left: 5px;\n        padding-right: 5px;\n        line-height: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
